import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnchorAdFormat = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 44 44",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 43,
			height: 43,
			rx: 1.5,
			fill: "white",
			stroke: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 4,
			width: 44,
			height: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 9,
			width: 36,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 13,
			width: 36,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 33,
			width: 36,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 37,
			width: 36,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 29,
			width: 36,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 21,
			width: 36,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 25,
			width: 36,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 17,
			width: 36,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 23,
			width: 40,
			height: 19,
			rx: 1,
			fill: "#30DCDC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.3669 25.6377C39.1894 25.4602 38.9027 25.4602 38.7253 25.6377L36.5 27.8584L34.2747 25.6331C34.0973 25.4556 33.8106 25.4556 33.6331 25.6331C33.4556 25.8106 33.4556 26.0973 33.6331 26.2747L35.8584 28.5L33.6331 30.7253C33.4556 30.9027 33.4556 31.1894 33.6331 31.3669C33.8106 31.5444 34.0973 31.5444 34.2747 31.3669L36.5 29.1416L38.7253 31.3669C38.9027 31.5444 39.1894 31.5444 39.3669 31.3669C39.5444 31.1894 39.5444 30.9027 39.3669 30.7253L37.1416 28.5L39.3669 26.2747C39.5398 26.1018 39.5398 25.8106 39.3669 25.6377Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M33.2796 25.2796C33.6523 24.9068 34.2556 24.9068 34.6283 25.2796L36.5004 27.1516L38.3717 25.2841C38.3718 25.284 38.3719 25.2839 38.372 25.2838C38.372 25.2838 38.372 25.2838 38.3721 25.2837C38.7448 24.9114 39.3478 24.9115 39.7204 25.2841C40.0886 25.6523 40.0886 26.2601 39.7204 26.6283L37.8487 28.5L39.7204 30.3717C40.0932 30.7444 40.0932 31.3477 39.7204 31.7204C39.3477 32.0932 38.7444 32.0932 38.3717 31.7204L36.5 29.8487L34.6283 31.7204C34.2556 32.0932 33.6523 32.0932 33.2796 31.7204C32.9068 31.3477 32.9068 30.7444 33.2796 30.3717L35.1513 28.5L33.2796 26.6283C32.9068 26.2556 32.9068 25.6523 33.2796 25.2796Z",
			fill: "white"
		})
	]
});
export default SvgAnchorAdFormat;
